
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RepairLaborGrid extends Serenity.EntityGrid<RepairLaborRow, any> {
        protected getColumnsKey() { return 'Repair.RepairLabor'; }
        protected getIdProperty() { return RepairLaborRow.idProperty; }
        protected getInsertPermission() { return RepairLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return RepairLaborRow.localTextPrefix; }
        protected getService() { return RepairLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}